

/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Space, Row, Col, Image } from "antd";
import { Button, FormControl, RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import GridViewNew from "../../../../Sales/Management/components/SelfBills/GridViewNew";
import usePrevious from "../../../../Shared/components/Previous";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { scrollToError, storageSetItem, checkProductSearch, checkBillProductView } from "../../../../../helpers/utilities";
import { toast } from 'react-toastify';
import { BillLineForm } from "../../../../Sales/Management/components/SelfBills/Blocks/BillLineForm";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../helpers/validation";
import unitActions from "../../../../Product/Setup/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { getRequest } from '../../../../../helpers/axiosClient';


export default function SupplierProducts(props) {
    const { visible, handleClose, clsx, classes, dispatch, productPrices, lines, productGstdetails, quote, order, purchase, locationApi,
        locationDetails,
        unitMesurementdetails, customObject, hsnApi, viewType, hsnDetails, businessDetails, supplierDetail, gstCalculation, priceIncludesTax,
        supplierId, debitNote, includeGst, productActions, lineSubmit, handleMyProductsLoad, extraClass } = props;
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    // const [search, setSearch] = useState('');
    const [productId, setProductId] = useState('');
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const [productGroupId, setProductGroupId] = useState('');
    const [priceList, setPriceList] = useState([]);
    //const prevSearch = usePrevious(search);
    // const [skip, setSkip] = useState(0);
    const [skip, setSkip] = useState(0);
    const [lineStock, setLineStock] = useState([]);
    const [stockLoading, setStockLoading] = useState(false);
    //const timeoutRef = useRef(null);
    const limit = 100;
    const [selected, setSelected] = useState([]);
    const [type, setType] = useState(viewType ? viewType : 'supplierProducts');
    const [supplierProducts, setSupplierProducts] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [changeSelected, setChangeSelected] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [formVisible, setFormVisible] = useState(false);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [showNameDesc, setShowNameDesc] = useState(checkBillProductView());
    const [errorLineForm, setErrorLineForm] = useState({});
    const [units, setUnits] = useState([]);


    useEffect(() => {
        if (visible) {
            dispatchFilter(type);
            locationApi();
            dispatch({
                type: unitActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
        }
    }, [visible]);

    useEffect(() => {
        if (lines.length) {
            setSelected(lines);
            setLineForm(calculateLineTotal({ ...lines[lines.length - 1], quantity: parseFloat(lines[lines.length - 1].quantity) }));
            if (productActions) {
                let d = lines[lines.length - 1];
                if (d?.hsnId) {
                    hsnApi('', d.hsnId);
                }
                setTimeout(() => {
                    handleUnits(lines[lines.length - 1]?.product);
                    handleStockUnits(lines[lines.length - 1].productId,
                        lines[lines.length - 1].unitId,
                        lines[lines.length - 1].quantity);
                }, 500);
            }
            setChangeSelected(!changeSelected);
        } else {
            setLineForm({});
        }
    }, [lines]);


    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {

                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (loadMore && getList.length === 0 && type === 'supplierProducts') {
            setSupplierProducts(true);
            handleTypeChange('myProducts');
        }
    }, [getList, loadMore]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 0 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(type, productGroupId);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(type, productGroupId);
                }, 500);
            }
        }
    }, [search]);


    const dispatchFilter = (type, productGroupId = '', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        if (handleMyProductsLoad) {
            handleMyProductsLoad();
        }

        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'PURCHASE' } }] }] };
        if (productGroupId) {
            filter['and'].push({ productGroupId: productGroupId });
        }
        let or = { ["or"]: [] };
        let array = ['productName', 'productId', 'description', 'type', 'barcode', 'code'];
        if (search !== '') {
            if (checkProductSearch() === 'both') {
                array = ['productName', 'code'];
            } else if (checkProductSearch() === 'name') {
                array = ['productName'];
            } else if (checkProductSearch() === 'code') {
                array = ['code'];
            } else if (checkProductSearch() === 'mrp') {
                array = ['mrp'];
            }
            array.map((el) => {
                if (el === 'code' || el === 'mrp') {
                    return or['or'].push({ [el]: search.trim() })
                } else {
                    return or['or'].push({ [el]: { like: '%' + search.trim() + '%' } })
                }
            });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: type === 'supplierProducts' ? `v1/schedules/supplier-products` : `client-products`,
            skip: skip,
            filter: {
                where: type === 'supplierProducts' ? { 'supplierId': supplierId } : filter,
                order: 'id desc',
                limit: limit,
                skip: skip,
            }
        });
    }

    useEffect(() => {
        if (productPrices && productPrices !== '' && productId !== '') {
            let selectedIndex = priceList?.findIndex(el => el.productId === productId);
            if (selectedIndex >= 0) {
                setPriceList(prevState => {
                    return prevState?.filter((value, i) => i !== selectedIndex)
                });
            } else {
                let data = {
                    productId: productId,
                    data: productPrices
                };
                setPriceList((prevState) => {
                    return [...prevState, data];
                });
            }
            // if (productId === 'single') {
            //     handleSinglePrice(lineForm, productPrices);
            // } else {
            //     handlePrice(productId, productPrices, selected);
            // }
            handleSinglePrice(lineForm, productPrices);
            handlePrice(productId, productPrices, selected);
            setProductId('');
        }
    }, [productPrices]);

    const handleSinglePrice = (lineForm, prices) => {
        let pricePerUnit = 0; let mrp = 0; let discount = 0; let discountAmount = 0; let discountRate = 0;
        // if ((prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0) ||
        //     (prices?.lastprice && Object.keys(prices?.lastprice).length > 0) ||
        //     (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0)) {
        if (prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
            prices?.priceagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            let result = prices?.priceagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name][0];
            if (result?.price) {
                pricePerUnit = result?.price;
            }
            if (result?.mrp) {
                mrp = result?.mrp;
            }
        } else {
            if (prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
                productPrices?.lastprice[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
                let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineForm?.unitId)?.name];
                if (result?.price) {
                    pricePerUnit = result?.price;
                }
                if (result?.mrp) {
                    mrp = result?.mrp;
                }
            }
        }

        if (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
            productPrices?.discountagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            let result = productPrices?.discountagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name][0];
            if (parameterDetails?.discountRate) {
                discountRate = result?.price || '';
            } else {
                discountAmount = result?.price || '';
            }
            if (result?.percentage) {
                discount = result?.percentage || '';
            }
        } else if (prices?.lastdiscount && Object.keys(prices?.lastdiscount).length > 0 &&
            prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            if (parameterDetails?.discountRate) {
                discountRate = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.rate || '';
            } else {
                discountAmount = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.amount || '';
            }
            discount = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.percent;
        }
        setLineForm({
            ...lineForm,
            'pricePerUnit': pricePerUnit || lineForm?.pricePerUnit || 0, 'maxRetailPrice': mrp || lineForm?.maxRetailPrice || 0,
            'discountPercent': discount, 'discountAmount': discountAmount, 'discountRate': discountRate || 0
        });
        // }
    }


    const handlePrice = (id, prices, selected) => {
        let selectedFilter = selected?.filter(el => el.productId === id);
        if (selectedFilter && selectedFilter?.length > 0) {
            // if ((prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0) ||
            //     (prices?.lastprice && Object.keys(prices?.lastprice).length > 0) ||
            //     (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0)) {
            let pricePerUnit = 0; let mrp = 0; let discount = 0; let discountAmount = 0;
            if (prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
                prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                let result = prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name][0];
                if (result?.price) {
                    pricePerUnit = result?.price;
                }
                if (result?.mrp) {
                    mrp = result?.mrp;
                }
            } else {
                if (prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
                    prices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name];
                    if (result?.price) {
                        pricePerUnit = result?.price;
                    }
                    if (result?.mrp) {
                        mrp = result?.mrp;
                    }
                }
            }

            if (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
                productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                let result = productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name][0];
                if (result?.price) {
                    discountAmount = result?.price || '';
                }
                if (result?.percentage) {
                    discount = result?.percentage || '';
                }
            } else if (prices?.lastdiscount && Object.keys(prices?.lastdiscount).length > 0 &&
                prices?.lastdiscount[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                discount = prices?.lastdiscount[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]?.percent;
            }

            const newTodos = selected.map((el) => {
                if (el.productId === id) {
                    return {
                        ...el, 'pricePerUnit': parseFloat(pricePerUnit || el?.pricePerUnit || 0), 'maxRetailPrice': mrp || el.maxRetailPrice || 0,
                        'discountPercent': discount, 'discountAmount': discountAmount
                    };
                }
                return el;
            });
            setSelected(newTodos);
            setChangeSelected(!changeSelected);
            // }
        }
    }

    useEffect(() => {
        if (selected && selected?.length > 0) {
            const newTodos = selected.map((el) => {
                return calculateLineTotal(el);
            });
            setSelected(newTodos);
            setLineForm(calculateLineTotal(lineForm));
        }
    }, [changeSelected]);


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(type, productGroupId, s);
    }

    const calculateLineTotal = (el) => {
        let data = {
            cgst: '', sgst: '', igst: '', cgstPercentage: '', sgstPercentage: '', igstPercentage: ''
        };
        const amount = el.quantity * el.pricePerUnit;
        let dPAmount = 0;
        let dTotal = 0;
        let gAmount = 0;
        data['purchaseValue'] = amount;
        if (el.discountPercent !== '') {
            dPAmount = dTotal = parseFloat((amount * el.discountPercent) / 100);
        }
        let discountAmount = el?.discountAmount || 0;
        const lineDiscountType = el?.discountType || 'perUnit';
        if (lineDiscountType === 'perUnit') {
            const qty = parseFloat(el?.quantity || 0);
            const rate = parseFloat(el?.discountRate || 0);
            discountAmount = Math.abs(qty) * Math.abs(rate);
            data['discountAmount'] = discountAmount;
        }
        if (discountAmount && discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(discountAmount);
            }
        }
        let tAmount = (amount - dTotal);
        data['amount'] = tAmount;

        if (el.productGstId && el.includeGst) {
            let gstDetails = productGstdetails?.filter((e) => { return e.id === el.productGstId });
            let percentage = gstDetails?.length > 0 ? gstDetails[0]?.percentage : 0;
            let details = {
                percentage: percentage,
                stateId: supplierDetail?.stateId,
                lineAmount: tAmount || 0,
                priceIncludesTax: priceIncludesTax
            };
            let gstCalc = gstCalculation(businessDetails, details, supplierDetail);
            // data['cgstPercentage'] = parseFloat(gstCalc.cgst);
            // data['sgstPercentage'] = parseFloat(gstCalc.sgst);
            // data['igstPercentage'] = parseFloat(gstCalc.igst);
            // data['cgst'] = parseFloat(gstCalc.cgstAmount);
            // data['sgst'] = parseFloat(gstCalc.sgstAmount);
            // data['igst'] = parseFloat(gstCalc.igstAmount);
            gAmount = gstCalc.gAmount;
        }

        if (el?.excisesApplicable) {
            let excisesAmount = 0;
            let splExcisesAmount = 0;
            if (el?.excisesType === 'perUnit') {
                const qty = parseFloat(el?.quantity || 0);
                const rate = parseFloat(el?.excisesRate || 0);
                excisesAmount = Math.abs(qty) * Math.abs(rate);
                data['excisesAmount'] = excisesAmount;
            } else {
                excisesAmount = el?.excisesAmount;
            }
            if (el?.excisesSplType === 'perUnit') {
                const sQty = parseFloat(el?.quantity || 0);
                const sRate = parseFloat(el?.excisesSplRate || 0);
                splExcisesAmount = Math.abs(sQty) * Math.abs(sRate);
                data['excisesSplAmount'] = splExcisesAmount;
            } else {
                splExcisesAmount = el?.excisesSplAmount || '';
            }
            let excisesTotal = parseFloat(excisesAmount || 0) + parseFloat(splExcisesAmount || 0) + parseFloat(el?.excisesAddAmount || 0);
            // console.log(splExcisesAmount);
            // console.log(excisesTotal);
            data['excisesTotal'] = parseFloat(el?.quantity || 0) < 0 ? -excisesTotal : excisesTotal;
            data['totalCostPrice'] = parseFloat(el?.quantity || 0) < 0 ? -(excisesTotal - (tAmount || 0)) : (excisesTotal + (tAmount || 0));
        }

        let result = {
            ...el,
            ...data,
            gstAmount: parseFloat(gAmount),
            discountPercAmount: dPAmount,
            discountCalcAmount: dTotal
        };
        return result;
    }

    const checkLineForm = (lineForm) => {
        let emptyDescription = emptyValidation('Description', lineForm?.description);
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineForm?.productGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineForm?.hsnId, 'dropDown');
        let ret = false;
        if ((lineForm?.includeGst && !emptyProductGst.isValid) || (lineForm?.includeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }

        let discountAgreeMents = true;
        let total = lineForm?.quantity * lineForm?.pricePerUnit;
        if (Math.abs(total) < Math.abs(lineForm?.discountCalcAmount)) {
            discountAgreeMents = false;
        }
        setLineError({});
        if (emptyDescription.isValid &&
            emptyUnit.isValid && discountAgreeMents &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && checkValidation
        ) {
            ret = true;
            setErrorLineForm({});
        } else {
            setLineError({
                description: emptyDescription?.errors || false,
                unitId: emptyUnit?.errors || false,
                discountAgreeMents: !discountAgreeMents ? 'Discount amount is greater than Line amount, please correct it.' : false,
                pricePerUnit: emptyPrice?.errors || false,
                quantity: emptyQuantity?.errors || false,
                productGstId: lineForm?.includeGst && emptyProductGst?.errors ? emptyProductGst?.errors : false,
                hsnId: lineForm?.includeGst && emptyHsn?.errors ? emptyHsn?.errors : false
            });
            setErrorLineForm(lineForm);
            ret = false;
        }

        return ret
    }

    const handleStockUnits = (productId, unitId, quantity) => {
        if (productId && unitId && quantity) {
            setStockLoading(true);
            getRequest(`${process.env.REACT_APP_API_URL}/check-stock-units/?productId=${productId}&unitId=${unitId}&quantity=${quantity}`)
                .then(response => {
                    setLineStock(prev => ({
                        ...prev,
                        [productId]: response.data
                    }));
                    setStockLoading(false);
                }).catch(error => {
                    console.error("Error fetching data", error);
                    setStockLoading(false);
                });
        }
    }

    const handleClick = (data, dataPro) => {
        if (productActions && lineForm && lineForm?.productId === data?.id) {
            let selectedSIngleIndex = selected?.findIndex(el => el.productId === lineForm.productId);
            if (selectedSIngleIndex >= 0) {
                setErrorLineForm({});
                setSelected(prevState => {
                    setLineForm(prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1]);
                    if (productActions) {
                        let d = prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1];
                        if (d?.hsnId) {
                            hsnApi('', d.hsnId);
                        }
                    }
                    return prevState.filter((value, i) => i !== selectedSIngleIndex)
                });
                setLineError({});
            }
            return false;
        }

        if (productActions && lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        let selectedIndex = selected?.findIndex(el => el.productId === data.id);
        if (selectedIndex >= 0) {
            setSelected(prevState => {
                setLineForm(prevState.filter((value, i) => i !== selectedIndex)[prevState.filter((value, i) => i !== selectedIndex).length - 1]);
                if (productActions) {
                    let d = prevState.filter((value, i) => i !== selectedIndex)[prevState.filter((value, i) => i !== selectedIndex).length - 1];
                    if (d?.hsnId) {
                        hsnApi('', d.hsnId);
                    }
                }
                return prevState.filter((value, i) => i !== selectedIndex)
            });
        } else {
            let d = {
                'productId': data?.id,
                'product': data,
                'quantity': parseFloat(debitNote ? `-${dataPro?.quantity || 1}` : `${dataPro?.quantity || 1}`),
                'description': data?.description || data?.productName || '',
                'unitId': data?.defaultPurchaseUnitId || data.salesUnitId,
                'unit': data?.defaultPurchaseUnit || data?.salesUnit,
                'maxRetailPrice': data?.mrp,
                'pricePerUnit': data?.latestPurchasePrice || 0,
                'gstAmount': 0,
                'amount': 0,
                'discountType': parameterDetails?.discountRate ? 'perUnit' : 'fixed',
                'discountRate': 0,
                'discountPercent': 0,
                'discountAmount': 0,
                'includeGst': includeGst,
                'productGstId': includeGst ? data?.productGstId : null,
                'productGst': includeGst ? data?.productGst : '',
                'hsnId': includeGst ? data?.hsnId : null,
                'hsn': includeGst ? data?.hsn : null,
                'excisesApplicable': data.exciseApplicable || false
            };

            if (order) {
                d.changed = true;
            }

            if (data.exciseApplicable) {
                d['includeGst'] = false;
                d['productGstId'] = '';
                d['productGst'] = '';
                d['excisesType'] = 'perUnit';
                d['excisesSplType'] = 'perUnit';
            }

            if (locationDetails && locationDetails?.length > 0) {
                let a = locationDetails?.filter(el => el.default);
                if (a?.length) {
                    d.locationId = a[0]?.id;
                } else {
                    d.locationId = locationDetails[0]?.id;
                }
            }

            if (productActions) {
                hsnApi('', data.hsnId);
            }

            if (includeGst && !data.exciseApplicable && !data?.productGstId) {
                if (productActions) {
                    setProductId('single');
                }
                setErrorLineForm({
                    ...calculateLineTotal(d)
                });
                setLineError({
                    productGstId: 'Please select/enter a valid value in Product GST Code',
                    hsnId: !d?.hsnId && 'Please select/enter a valid value in HSN'
                });
                setTimeout(() => {
                    scrollToError();
                    setTimeout(() => {
                        document.getElementById('DD-SSL-product-gst-code').focus();
                    }, 100);
                }, 100);
            } else {
                if (productActions) {
                    setProductId(data.id);
                }
            }


            setSelected((prevState) => {
                return [...prevState, calculateLineTotal(d)];
            });

            setLineForm({ ...calculateLineTotal(d) });
            handleStockUnits(d?.productId, d?.unitId, Math.abs(d?.quantity));
            handleUnits(data);
        }

        if (productActions) {
            setChangeSelected(!changeSelected);
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/purchasedprice/${supplierId}/${data?.id}`
            });
        }

        // if (lineForm?.productId === data?.id) {
        //     let selectedSIngleIndex = selected?.findIndex(el => el.productId === lineForm.productId);
        //     if (selectedSIngleIndex >= 0) {
        //         setSelected(prevState => {
        //             setLineForm(prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1]);
        //             return prevState.filter((value, i) => i !== selectedSIngleIndex)
        //         });
        //         setLineError({});
        //     }
        //     return false;
        // } else {
        //     if (Object.keys(lineError)?.length > 0) {
        //         toast.dismiss();
        //         toast.error('Please select value in the highlighted mandatory field');
        //         return false;
        //     }
        // }
    };

    const changeHandlerLine = (data, e, name = '', relation = '') => {
        const newTodos = selected.map((el) => {
            if (el.productId === data.productId) {
                let o = {};
                if (order) {
                    o.changed = true;
                }
                if (relation) {
                    setLineForm({
                        ...data, [name]: e.id, [relation]: e
                    });
                    if (name === 'unitId') {
                        handleSinglePrice({ ...data, [name]: e.id, [relation]: e }, productPrices);
                        handleStockUnits(data?.productId, e.id, Math.abs(data?.quantity));
                    }
                    return { ...el, [name]: e.id, [relation]: e, ...o };
                } else {
                    if (name === 'discountRate') {
                        if (lineForm?.discountType === 'perUnit') {
                            let va = lineForm?.quantity < 0 ? 0 : lineForm?.quantity;
                            data['discountAmount'] = parseFloat((parseFloat(e) * parseFloat(va)).toFixed(2));
                        }
                    } else if (name === 'quantity') {
                        handleStockUnits(data?.productId, data?.unitId, Math.abs(e));
                    }
                    setLineForm({
                        ...data, [name]: e
                    });
                    return { ...el, [name]: e, ...o };
                }
            }
            return el;
        });

        setSelected(newTodos);
        setChangeSelected(!changeSelected);

    }

    const handleQuantityChange = (data, v) => {
        let newTodos = [];

        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        if (v === 'decrease') {
            if (data.quantity === 1) {
                setSelected(prevState => {
                    setLineForm(prevState.filter((el, i) => el.productId !== data.productId)[prevState.filter((el, i) => el.productId !== data.productId).length - 1]);
                    return prevState.filter((el, i) => el.productId !== data.productId)
                });
                return true;
            } else {
                newTodos = selected.map((el) => {
                    if (el.productId === data.productId) {
                        let d = { ...el, 'quantity': parseInt(el.quantity) - parseInt(1) };
                        if (order) {
                            d.changed = true;
                        }
                        setLineForm(d);
                        handleStockUnits(el?.productId, el.unitId, Math.abs(parseInt(el.quantity) - parseInt(1)));
                        return d;
                    }
                    return el;
                });
            }
        } else {
            if (data.quantity === -1) {
                setSelected(prevState => {
                    setLineForm(prevState.filter((el, i) => el.productId !== data.productId)[prevState.filter((el, i) => el.productId !== data.productId).length - 1]);
                    return prevState.filter((el, i) => el.productId !== data.productId)
                });
                return true;
            } else {
                newTodos = selected.map((el) => {
                    if (el.productId === data.productId) {
                        let d = { ...el, 'quantity': parseInt(el.quantity) + parseInt(1) };
                        if (order) {
                            d.changed = true;
                        }
                        handleStockUnits(el?.productId, el.unitId, Math.abs(parseInt(el.quantity) + parseInt(1)));
                        setLineForm(d);
                        return d;
                    }
                    return el;
                });
            }
        }
        hsnApi('', data.hsnId);
        setSelected(newTodos);
        setChangeSelected(!changeSelected);
    }

    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultPurchaseUnitId || data?.salesUnitId) }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultPurchaseUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }
                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(prev => {
                    const current = prev[data?.id] || [];  // Get existing array or empty array
                    return {
                        ...prev,
                        [data?.id]: [...current, ...filtered]  // Append `filtered` array
                    };
                });
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    // const handleLineSubmit = () => {
    //     if (!checkLineForm(lineForm)) {
    //         toast.dismiss();
    //         toast.error('Please select value in the highlighted mandatory field');
    //         return;
    //     }

    //     const updatedLines = (selected ?? []).map((element) => {
    //         const stockData = lineStock?.[element.productId];
    //         const {
    //             discountCalcAmount,
    //             discountPercAmount,
    //             location,
    //             batchDetails,
    //             ...rest
    //         } = element;

    //         return {
    //             ...rest,
    //             stockQuantity: stockData?.quantity ?? null,
    //             stockUnitId: stockData?.unitId ?? null,
    //             stockUnit: stockData?.unit ?? null,
    //             ...(quote ? {} : { batchDetails })
    //         };
    //     });

    //     lineSubmit(updatedLines);
    // };

    const handleLineSubmit = () => {
        if (!checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return;
        }

        const cleanedLines = (selected ?? []).map((item) => {
            const element = { ...item };

            // Remove unwanted fields
            delete element.discountCalcAmount;
            delete element.discountPercAmount;
            delete element.location;

            // 📦 Stock update logic
            const stockData = lineStock?.[element.productId];

            element.stockQuantity = stockData?.quantity ?? null;
            element.stockUnitId = stockData?.unitId ?? null;
            element.stockUnit = stockData?.unit ?? null;

            // Quote-specific cleanup
            if (quote) {
                delete element.locationId;
                delete element.batchDetails;
            }

            return element;
        });

        lineSubmit(cleanedLines);
    };


    const handleTypeChange = (value) => {
        setType(value);
        dispatchFilter(value, productGroupId);
    }

    const handleLineForm = (type, val) => {
        const index = selected.findIndex((a) => a.productId === val);
        if (index >= 0) {
            if (type === 'prev') {
                setLineForm(selected[index - 1]);
                let d = selected[index - 1];
                if (d?.hsnId) {
                    hsnApi('', d.hsnId);
                }
                handleStockUnits(d.productId, d.unitId, d.quantity);
                handleUnits(d.product);
            } else {
                setLineForm(selected[index + 1]);
                let d = selected[index + 1];
                if (d?.hsnId) {
                    hsnApi('', d.hsnId);
                }
                handleStockUnits(d.productId, d.unitId, d.quantity);
                handleUnits(d.product);
            }

        }
    }

    const handleGroupChange = (v) => {
        setProductGroupId(v);
        dispatchFilter(type, v);
    }

    const changeSearchType = (value) => {
        storageSetItem('productSearch', value);
        dispatchFilter(type, productGroupId);
    }

    const handleDisplayChange = (val) => {
        storageSetItem('billProductView', val);
        setShowNameDesc(val);
    }

    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            width={productActions ? (selected.length ? '1000px' : '650px') : '690px'}
            title={'Add Purchase Lines'}
            className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
            component={
                <div className={clsx(classes.customForm, classes.customFormProducts, classes.removeUnderline, extraClass)}>
                    <div className={clsx(classes.customFormLeft, { [classes.customFormLeftSel]: selected.length > 0 && productActions })}>
                        <div className={clsx(classes.customFormFlex, classes.customFormFlexProducts, { [classes.customFormFlexGrid]: selected.length > 0 })}>
                            {
                                type === 'myProducts' && <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <div style={{ marginBottom: 10 }} className={clsx(classes.dropDownWithSearch, classes.customerLabelNone)}>
                                            <AutoCompleteComponent
                                                customLabel={"Type"}
                                                heads={[{ 'key': 'label', 'name': 'Search Configuration' }]}
                                                details={[{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }]}
                                                parentValue={customObject([{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }], checkProductSearch())}
                                                position={"bottom"}
                                                variant={'outlined'}
                                                onChange={(data) => changeSearchType(data.id)}
                                            />
                                            <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                                <TextField autoComplete='one-time-code'
                                                    placeholder={
                                                        checkProductSearch() === 'standard' ? 'Search Name, ID, Bar Code, and Code' :
                                                            checkProductSearch() === 'both' ? 'Search Name, and Code' :
                                                                checkProductSearch() === 'name' ? 'Search Name' :
                                                                    checkProductSearch() === 'code' ? 'Search Code' :
                                                                        checkProductSearch() === 'mrp' ? 'Search MRP' : ''
                                                    }
                                                    value={search}
                                                    type='search'
                                                    variant={'standard'}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    fullWidth
                                                    onFocus={() => setIconAnimation(true)}
                                                    onBlur={() => setIconAnimation(false)}
                                                />
                                                <Image src={SearchIcon} preview={false} />
                                                {
                                                    search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                        <Image
                                                            src={ClearIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Row style={{ height: type !== 'myProducts' ? "100%" : "calc(100% - 45px)" }}>
                                <Col span={16} className={clsx(classes.prod_group)} style={{ height: "calc(100% - 32px)" }}>
                                    <FormControl
                                        style={{ marginBottom: 10 }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                        variant={'standard'}
                                        fullWidth >
                                        <RadioGroup
                                            row
                                            value={type}
                                            onChange={(e) => handleTypeChange(e.target.value)}>
                                            {
                                                viewType ? '' : <FormControlLabel value="supplierProducts" disabled={supplierProducts} control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Supplier Products" />
                                            }
                                            <FormControlLabel value="myProducts" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="My Products" />
                                        </RadioGroup>
                                    </FormControl>
                                    <GridViewNew
                                        {...props}
                                        type={type}
                                        loadTasks={() => dispatchFilter(type, productGroupId)}
                                        details={getList}
                                        loadMore={loadMore}
                                        loadMoreContent={loadMoreContent}
                                        loadMoreTask={() => loadMoreTask()}
                                        classes={classes}
                                        clsx={clsx}
                                        salesType={debitNote ? 'Sale Return' : 'Sales'}
                                        selected={selected}
                                        productId={productId}
                                        errorLineForm={errorLineForm}
                                        handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                        changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                        handleGridClick={(data, dataPro) => handleClick(data, dataPro)}
                                        visible={formVisible}
                                        handleClose={(v) => setFormVisible(v)}
                                        lineError={lineError}
                                        form={lineForm}
                                        showNameDesc={showNameDesc}
                                        stockLoading={stockLoading}
                                    />
                                </Col>
                                <Col span={8} style={{ padding: "0px 0px 0px 10px", height: "calc(100% - 30px)" }}>
                                    <FormControl
                                        style={{ marginBottom: 10 }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={showNameDesc}
                                            onChange={(e) => handleDisplayChange(e.target.value)}>
                                            <FormControlLabel value="name" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Name" />
                                            <FormControlLabel value="description" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Description" />
                                        </RadioGroup>
                                    </FormControl>
                                    <div className={clsx(classes.heightFull, { [classes.disabled]: type === 'customerProducts' })} style={{ overflow: "auto", marginRight: "-10px", paddingRight: 10, paddingBottom: 5 }}>
                                        <NavLink to={'#'} onClick={() => handleGroupChange('')} className={clsx(classes.listprod, { [classes.listprodactive]: productGroupId === '' })}>All Products</NavLink>
                                        {
                                            productGroupDetails && productGroupDetails?.map((el, i) => (
                                                <NavLink to={'#'} onClick={() => handleGroupChange(el.id)} key={i} className={clsx(classes.listprod, { [classes.listprodactive]: productGroupId === el.id })}>{showNameDesc === 'name' ? el.name : (el?.description || '---')}</NavLink>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="Add"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleLineSubmit()}
                                    className={clsx(classes.modalBtn)}>
                                    Add
                                </Button>
                            </Space>
                        </div>
                    </div>
                    <div className={clsx(classes.customFormRight, { [classes.customFormRightSel]: selected.length > 0 && productActions })}>
                        <BillLineForm
                            {...props}
                            visible={visible}
                            form={lineForm}
                            parentForm={{ includeGst: includeGst }}
                            error={lineError}
                            salesType={debitNote ? 'Sale Return' : 'Sales'}
                            view={false}
                            productGstdetails={productGstdetails}
                            unitMesurementdetails={unitMesurementdetails}
                            hsnDetails={hsnDetails}
                            classes={classes}
                            handleClose={() => handleClose(false)}
                            customObject={(details, id) => customObject(details, id)}
                            changeHandlerLine={(e, name = '', relation = '') => changeHandlerLine(lineForm, e, name, relation)}
                            handleLineSubmit={(e) => handleLineSubmit(e)}
                            hsnApi={(s) => hsnApi(s)}
                            handleLineForm={(type, val) => handleLineForm(type, val)}
                            selected={selected}
                            purchase={purchase}
                            units={units}
                            parameterDetails={parameterDetails}
                            showNameDesc={showNameDesc}
                            lineStock={lineStock}
                        />
                    </div>
                </div>
            }
        />
    )
}